export default __webpack_public_path__ + "static/media/pole_motorsport.8f68dfdc.png";